import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    type: 1,
    image: '',
    video: '',
    title: '',
    description: '',
    textColor: '#000000',
    cta: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: 'original',
    height: 200,
    darkness: 0,
  },
  containerDesign: {},
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    bannerStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { buttonDesign, itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        type: blockContent.type ?? 1,
        image: blockContent.image ?? '',
        video: blockContent.video ?? '',
        title: blockContent.title ?? '',
        description: blockContent.description ?? '',
        textColor: blockContent.textColor ?? '#000000',
        cta: blockContent.cta ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: blockDesign.layout ?? 'original',
        height: blockDesign.height ?? 200,
        darkness: blockDesign.darkness ?? 0,
      };
    },
    bannerClear: () => initialState,

    bannerUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    bannerUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    bannerUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    bannerUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { bannerStore, bannerClear, bannerUpdateIsLoading, bannerUpdateIsActive, bannerUpdateBlockContent, bannerUpdateBlockDesign } = bannerSlice.actions;

export const selectBannerIsLoading = (state) => state.banner.isLoading;

export const selectBannerId = (state) => state.banner.id;
export const selectBannerUID = (state) => state.banner.uid;
export const selectBannerSID = (state) => state.banner.sid;

export const selectBannerBlockContent = (state) => state.banner.blockContent;

export const selectBannerBlockDesign = (state) => state.banner.blockDesign;
export const selectBannerContainerDesign = (state) => state.banner.containerDesign;

export default bannerSlice.reducer;
